import { Typography, Box } from "@mui/material" 
import FormDescription from '../../../inputFormComponents/FormDescription'

const DescriptionUserBankAccount = () => {
  return (
    <FormDescription 
      paragraphs={[
        <Box key={1}>
          <Typography variant="body1">Bankverbindung:</Typography>
          <Typography variant="body2">Gib hier die Bankverbindung ein, die später auf deiner Rechnung verwendet werden soll. Die Angabe ist für die spätere Rechnungserstellung zwingend notwendig.</Typography>
        </Box>,

      ]}
    />
  )
}

export default DescriptionUserBankAccount